module.exports = __webpack_public_path__ + "static/media/anuncio@2x.5f0bdb0e.png";